<!-- 左侧菜单 -->
<template>
  <div class="nav">
    <el-menu
      :default-active="active"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      :collapse="isCollapse"
      :unique-opened="true"
      background-color="#ffffff"
      text-color="#000"
      active-text-color="#fff"
    >
      <template v-for="item in navData">
        <!-- 一级导航 -->
        <el-menu-item
          :index="item.id"
          v-if="!item.children && !item.hide"
          :key="item.id"
          @click="itemBtn(item)"
        >
          <i :class="item.icon"></i>
          <span slot="title">{{ item.label }}</span>
        </el-menu-item>
        <!-- 存在二级的一级导航 -->
        <el-submenu :index="item.id" :key="item.id + 1" v-if="item.children && !item.hide">
          <template slot="title">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.label }}</span>
          </template>
          <!-- 二级 -->
          <div v-for="(item_next, index_next) in item.children" :key="index_next">
            <el-menu-item
              :index="item_next.id"
              v-if="!item_next.children && !item_next.hide"
              @click="itemBtn(item_next)"
            >
              <span slot="title">{{ item_next.label }}</span>
            </el-menu-item>
            <!-- 存在三级的二级导航 -->
            <el-submenu :index="item_next.id" v-if="item_next.children && !item_next.hide">
              <span slot="title">{{ item_next.label }}</span>
              <!-- 三级 -->
              <template v-for="(item_next_next, index_next_next) in item_next.children">
                <el-menu-item
                  v-if="!item_next_next.hide"
                  :key="index_next_next"
                  :index="item_next_next.id"
                  @click="itemBtn(item_next_next)"
                >{{ item_next_next.label }}</el-menu-item>
              </template>
            </el-submenu>
          </div>
        </el-submenu>
      </template>
    </el-menu>

    <!-- 底部折叠按钮 -->
    <div class="collapse-btn" @click="collapseBtn">
      <img src="@/image/nav_icon/daohang.png" alt v-if="isCollapse" style="width: 100%" />
      <img src="@/image/nav_icon/zhedie.png" alt v-else style="width: 100%" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Nav",
  components: {},
  props: {
    isCollapse: {
      type: Boolean,
      default: true
    },
    navData: {
      type: Array
    },
    active: {
      type: String
    }
  },
  data() {
    return {};
  },
  methods: {
    itemBtn(item, index) {
      this.$emit("clickNav", item, index);
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    collapseBtn() {
      this.$emit("collapse");
    }
  }
};
</script>

<style scoped lang="less">
.nav {
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  background: #ffffff;
  position: relative;
  display: flex;
  flex-direction: column;

  .collapse-btn {
    position: fixed;
    bottom: 20px;
    left: 20px;
    width: 22px;
    cursor: pointer;
    z-index: 999;
    transition: all 0.3s;

    &:hover {
      opacity: 0.7;
    }
  }
}

// .el-menu-vertical-demo:not(.el-menu--collapse) {
//   width: 200px;
//   min-height: 400px;
// }
/* 菜单选中后的颜色 */

/deep/ .el-submenu__title {
  border-radius: 20px;
  margin: 5px 10px;
  letter-spacing: 2px;
  
  &:hover {
    background-color: #f0f4f3 !important;
  }
}

/* 子项选中时父项文字颜色 */
/deep/ .el-submenu.is-opened > .el-submenu__title,
/deep/ .el-submenu.is-active > .el-submenu__title {
  color: #65d27d !important;
}

.el-menu .el-menu-item {
  border-radius: 20px;
  margin: 5px 10px;
  letter-spacing: 2px;
}

.el-menu .el-menu-item.is-active {
  background-color: #65d27d !important;
}

/* 点击二级菜单时多出的一像素边框问题 */
.el-menu {
  border-right: none;
}

/* 子菜单hover颜色处理 */
.el-menu-item:hover {
  background-color: #f0f4f3 !important;
}
</style>
